"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ResultHeader = _interopRequireDefault(require("./ResultHeader"));

var _ResultInfo = _interopRequireDefault(require("./ResultInfo"));

var _ResultSection = _interopRequireDefault(require("./ResultSection"));

var _GradeTypeConstants = _interopRequireDefault(require("../../constants/GradeTypeConstants"));

var _Tag = _interopRequireDefault(require("./Tag"));

var YesNoResultSection =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(YesNoResultSection, _React$Component);

  function YesNoResultSection() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, YesNoResultSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(YesNoResultSection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getTickOrXIconClasses = function () {
      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
          props = _assertThisInitialize.props;

      return (0, _classnames.default)({
        icon: true,
        'icon-check-circle': props.gradeType === _GradeTypeConstants.default.GOOD,
        'icon-delete-circle': props.gradeType === _GradeTypeConstants.default.BAD
      });
    };

    return _this;
  }

  (0, _createClass2.default)(YesNoResultSection, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return _react.default.createElement(_ResultSection.default, {
        gradeType: props.gradeType
      }, _react.default.createElement(_Tag.default, props), _react.default.createElement(_ResultHeader.default, props), _react.default.createElement("div", {
        className: this.getTickOrXIconClasses()
      }), _react.default.createElement(_ResultInfo.default, props));
    }
  }]);
  return YesNoResultSection;
}(_react.default.Component);

exports.default = YesNoResultSection;
YesNoResultSection.propTypes = {
  gradeType: _propTypes.default.string
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/result/YesNoResultSection.js
// module id = 299
// module chunks = 0